import { createContext, useContext, useState, useEffect } from 'react';
import { getPerfilAcessos } from '../services/api_perfil_acesso';
import { useAuth } from './AuthProvider';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth(); // Token de autenticação do usuário

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const idPerfil = localStorage.getItem("idPerfil"); // Pega o ID do perfil do localStorage
        //console.log(idPerfil, 'este é o meu perfil')
        if (idPerfil) {
          const response = await getPerfilAcessos(idPerfil);
          //console.log(response) // Passa o ID do perfil para a função que carrega as permissões
          const permissaoAcesso = response?.pessoa || [];
          setPermissions(permissaoAcesso);
        } else {
          console.error('ID do perfil não encontrado no localStorage.');
        }
      } catch (error) {
        console.error('Erro ao obter permissões:', error);
      } finally {
        setLoading(false);
      }
    };

    if (token) { // Verifica se o usuário está autenticado antes de tentar carregar as permissões
      fetchPermissions();
    }
  }, [token]);

  return (
    <PermissionsContext.Provider value={{ permissions, loading }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
